/**
 * @description AdjustMarginLink Component
 */
import { TRADE_OVERLAY_TYPE, TRADE_TYPE } from '@/constants/trade';
import { resetLiquidityFormByChainId } from '@/features/earn/action';
import { useTradeType } from '@/features/trade/hooks';
import { useTradeStore } from '@/features/trade/store';
import { useAppDispatch } from '@/hooks';
import classNames from 'classnames';
import { FC, useCallback } from 'react';
import AdjustIcon from './assets/adjust.svg?react';
import './index.less';

interface AdjustMarginLinkProps {
  chainId?: number;
  pairSymbol?: string;
  className?: string;
}

export const AdjustMarginLink: FC<AdjustMarginLinkProps> = ({ chainId, pairSymbol, className }) => {
  const dispatch = useAppDispatch();
  const tradeType = useTradeType(chainId);

  const { setShowTradeAreaOverlay, setClosePositionPairSymbol } = useTradeStore();

  const adjustMargin = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      e.stopPropagation();
      if (!pairSymbol) {
        return;
      }
      // pairPageNavigate(pairSymbol, PAIR_PAGE_TYPE.TRADE);
      if (tradeType !== TRADE_TYPE.ADJUST_MARGIN) {
        setClosePositionPairSymbol(pairSymbol);
        setShowTradeAreaOverlay(TRADE_OVERLAY_TYPE.ADJUST_MARGIN);
        chainId && dispatch(resetLiquidityFormByChainId({ chainId }));
      }
    },
    [chainId, dispatch, pairSymbol, tradeType, setShowTradeAreaOverlay, setClosePositionPairSymbol],
  );

  return (
    <a
      className={classNames(
        'syn-adjust-margin-link',
        tradeType === TRADE_TYPE.ADJUST_MARGIN && 'syn-btn-active',
        className,
      )}
      onClick={adjustMargin}>
      <AdjustIcon className="syn-icon" />
    </a>
  );
};

export default AdjustMarginLink;
